import "whatwg-fetch"; // polyfill for older browsers
import {
  getAPIConfig,
  convertQueryObjToString,
  handleAPIResponse,
  getSyPICommercialAPIConfig,
} from "@utils/browser-helpers";
import { executeAPIRequest } from "@adapters/api";
var schemaManagementAdapter = {
  fetchSMConfig: async (fetchConfig = {}, configCTID = "") => {
    const { isCommercial, BRCRoute } = getSyPICommercialAPIConfig();
    let configRoute = `${BRCRoute}/sm_s3_configs${
      fetchConfig ? `${convertQueryObjToString(fetchConfig)}` : ""
    }`;
    const configApiConfig = getAPIConfig(configRoute, !isCommercial);
    configApiConfig.url = configCTID
      ? configApiConfig.url.replace(localStorage.ctid, configCTID)
      : configApiConfig.url;
    const configResponse = await executeAPIRequest(configApiConfig, "GET");
    const configResponseData = await configResponse.json();
    return handleAPIResponse(configResponseData);
  },
  fetchSMConfigReleaseVersions: async (fetchConfig = {}, configCTID = "") => {
    const { isCommercial, BRCRoute } = getSyPICommercialAPIConfig();
    let configRoute = `${BRCRoute}/sm_s3_configs/list${
      fetchConfig ? `${convertQueryObjToString(fetchConfig)}` : ""
    }`;
    const configApiConfig = getAPIConfig(configRoute, !isCommercial);
    configApiConfig.url = configCTID
      ? configApiConfig.url.replace(localStorage.ctid, configCTID)
      : configApiConfig.url;
    const configResponse = await executeAPIRequest(configApiConfig, "GET");
    const configResponseData = await configResponse.json();
    return handleAPIResponse(configResponseData);
  },
  updateSMConfigReleaseVersions: async (configCTID = "", smChanges = {}) => {
    const { isCommercial, BRCRoute } = getSyPICommercialAPIConfig();
    let configRoute = `${BRCRoute}/sm_s3_configs/list`;
    const configApiConfig = getAPIConfig(configRoute, !isCommercial);
    configApiConfig.url = configCTID
      ? configApiConfig.url.replace(localStorage.ctid, configCTID)
      : configApiConfig.url;
    const configResponse = await executeAPIRequest(
      configApiConfig,
      "PATCH",
      null,
      smChanges
    );
    const configResponseData = await configResponse.json();
    return handleAPIResponse(configResponseData);
  },
  fetchSMSchemaReleaseVersions: async (fetchConfig = {}, schemaCTID = "") => {
    const { isCommercial, BRCRoute } = getSyPICommercialAPIConfig();
    let schemaRoute = `${BRCRoute}/sm_s3_configs/schema/list${
      fetchConfig ? `${convertQueryObjToString(fetchConfig)}` : ""
    }`;
    const schemaApiConfig = getAPIConfig(schemaRoute, !isCommercial);
    schemaApiConfig.url = schemaCTID
      ? schemaApiConfig.url.replace(localStorage.ctid, schemaCTID)
      : schemaApiConfig.url;
    const schemaResponse = await executeAPIRequest(schemaApiConfig, "GET");
    const schemaResponseData = await schemaResponse.json();
    return handleAPIResponse(schemaResponseData);
  },
  updateSMSchema: async (changes = null) => {
    const { isCommercial, BRCRoute } = getSyPICommercialAPIConfig();
    let updateSchemaRoute = `${BRCRoute}/sm_s3_configs/schema`;
    const updateSchemaApiConfig = getAPIConfig(
      updateSchemaRoute,
      !isCommercial
    );
    const updateSchemaResponse = await executeAPIRequest(
      updateSchemaApiConfig,
      "POST",
      null,
      changes
    );
    const updateSchemaResponseData = await updateSchemaResponse.json();
    return handleAPIResponse(updateSchemaResponseData, null, true);
  },
  updateSMConfig: async (configChanges, fetchConfig = "") => {
    const { isCommercial, BRCRoute } = getSyPICommercialAPIConfig();
    let configRoute = `${BRCRoute}/sm_s3_configs${fetchConfig ? `/${fetchConfig}` : ""}`;
    const apiSMConfig = getAPIConfig(configRoute, !isCommercial);
    const configResponse = await executeAPIRequest(
      apiSMConfig,
      "POST",
      null,
      configChanges
    );
    const configResponseData = await configResponse.json();
    return handleAPIResponse(configResponseData, null, true);
  },
  fetchSchema: async (fetchConfig = {}, schemaCTID = "") => {
    const { isCommercial, BRCRoute } = getSyPICommercialAPIConfig();
    let schemaRoute = `${BRCRoute}/sm_s3_configs/schema${
      fetchConfig ? `${convertQueryObjToString(fetchConfig)}` : ""
    }`;
    const schemaApiConfig = getAPIConfig(schemaRoute, !isCommercial);
    schemaApiConfig.url =
      schemaCTID && localStorage.ctid
        ? schemaApiConfig.url.replace(localStorage.ctid, schemaCTID)
        : schemaCTID && !localStorage.ctid
          ? schemaApiConfig.url.replace("//", `/${schemaCTID}/`)
          : schemaApiConfig.url;
    const schemaResponse = await executeAPIRequest(schemaApiConfig, "GET");
    const schemaResponseData = await schemaResponse.json();
    return handleAPIResponse(schemaResponseData);
  },
  fetchScheduledDraftList: async (scheduledDraft, isCommercial = false) => {
    let route = `${
      isCommercial ? `/commercial/${localStorage.ctid}` : ""
    }/sm_config_scheduler${
      scheduledDraft ? `${convertQueryObjToString(scheduledDraft)}` : ""
    }`;
    const apiConfig = getAPIConfig(route, !isCommercial);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  fetchHistoryConfig: async (fetchConfig) => {
    const { isCommercial, BRCRoute } = getSyPICommercialAPIConfig();
    let route = `${BRCRoute}/sm_config_scheduler/history${
      fetchConfig ? convertQueryObjToString(fetchConfig) : ""
    }`;
    const apiConfig = getAPIConfig(route, !isCommercial);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  saveScheduledConfig: async (changes, isCommercial = false) => {
    let route = `${
      isCommercial ? `/commercial/${localStorage.ctid}` : ""
    }/sm_config_scheduler/scheduled`;
    const apiConfig = getAPIConfig(route, !isCommercial);
    const response = await executeAPIRequest(apiConfig, "POST", null, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData, null, true);
  },
  saveDraftedConfig: async (changes, isCommercial = false) => {
    let route = `${
      isCommercial ? `/commercial/${localStorage.ctid}` : ""
    }/sm_config_scheduler/draft`;
    const apiConfig = getAPIConfig(route, !isCommercial);
    const response = await executeAPIRequest(apiConfig, "POST", null, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData, null, true);
  },
  deleteScheduledConfig: async (fetchConfig, isCommercial = false) => {
    let route = `${
      isCommercial ? `/commercial/${localStorage.ctid}` : ""
    }/sm_config_scheduler/scheduled${
      fetchConfig ? convertQueryObjToString(fetchConfig) : ""
    }`;
    const apiConfig = getAPIConfig(route, !isCommercial);
    const response = await executeAPIRequest(apiConfig, "DELETE");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  deleteDraftConfig: async (fetchConfig, isCommercial = false) => {
    let route = `${
      isCommercial ? `/commercial/${localStorage.ctid}` : ""
    }/sm_config_scheduler/draft${
      fetchConfig ? convertQueryObjToString(fetchConfig) : ""
    }`;
    const apiConfig = getAPIConfig(route, !isCommercial);
    const response = await executeAPIRequest(apiConfig, "DELETE");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  deleteHistoryConfig: async (fetchConfig, isCommercial = false) => {
    let route = `${
      isCommercial ? `/commercial/${localStorage.ctid}` : ""
    }/sm_config_scheduler/history${
      fetchConfig ? convertQueryObjToString(fetchConfig) : ""
    }`;
    const apiConfig = getAPIConfig(route, !isCommercial);
    const response = await executeAPIRequest(apiConfig, "DELETE");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  fetchScheduledConfig: async (fetchConfig, isCommercial = false) => {
    let route = `${
      isCommercial ? `/commercial/${localStorage.ctid}` : ""
    }/sm_config_scheduler/scheduled${
      fetchConfig ? convertQueryObjToString(fetchConfig) : ""
    }`;
    const apiConfig = getAPIConfig(route, !isCommercial);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  fetchDraftConfig: async (fetchConfig, isCommercial = false) => {
    let route = `${
      isCommercial ? `/commercial/${localStorage.ctid}` : ""
    }/sm_config_scheduler/draft${
      fetchConfig ? convertQueryObjToString(fetchConfig) : ""
    }`;
    const apiConfig = getAPIConfig(route, !isCommercial);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
};

window.schemaManagementAdapter = schemaManagementAdapter;

export default schemaManagementAdapter;
